export default __webpack_public_path__ + "static/media/logo-gear.04d32924.svg";